import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is a Web3 development company?",
    answer: `<p>Web3 companies that develop Web3 technologies are at the forefront of the decentralized online trend. Their technical proficiency and industry knowledge enable them to develop innovative solutions that leverage blockchain technology and provide people with greater autonomy over their digital experiences.</p>`,
  },
  {
    question: "What are Web3 services?",
    answer: `<p>Web3 is referred to as a new version of the internet-fueled by blockchain technology, tokenization, and decentralization.</p>`,
  },
  {
    question: "What does a Web3 developer do?",
    answer: `<p>Web3 developers are adept at building decentralized applications with blockchain technology. By utilizing new tools, programming languages, and technologies, they create Web3 apps more easily.</p>`,
  },
  {
    question:
      "What programming languages and frameworks do your developers specialize in?",
    answer: `<p>Our Web 3 developers are familiar with both Solidity and Rust languages when creating Web 3 applications. In addition, they also use a range of other blockchain networks e.g. Brownie, and Substrate which are important for creating dApps and blockchain apps in the future.</p> `,
  },
  {
    question: "How much will Web3 application development cost?",
    answer: `<p>The complexity and features of a Web3 application determine how much it will cost to construct. However, the average cost of developing Web3 apps can range from:</p>
    <div class="table-responsive">
    <table class="table table-bordered">
    <thead>
    <tr>
      <th scope="col">Web3 Solutions</th>
      <th scope="col">Web3 app development cost</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Simple Web3 app</td>
      <td>$20,000-$50,000</td>
    </tr>
    <tr>
    <td>Mid-level Web3 app</td>
    <td>$50,000-$100,000</td>
  </tr>
  <tr>
  <td>Complex Web3 app</td>
  <td>$100,000-$200,000+</td>
  </tr>
  </tbody>
    </table>
  </div>`,
  },
  {
    question: "Are Web3 development services customizable?",
    answer: `<p>Yes, our Web3 developers can help you fully personalize the Web3 development services, including the design and functionality.</p>`,
  },
  {
    question: "How can TekRevol help you with Web 3.0 development?",
    answer: `<p>We provide full-stack development support and direction, our Web3 developers employ unique code and architectural designs to accomplish your goals. They know how to use cutting-edge technology like dApps, smart contracts, and blockchain that are specifically designed to meet your business goals.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Web3 Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
